import { styled, css } from '@xstyled/styled-components';
import { AnimatePresence } from 'framer-motion';

import { StyledComponent, x } from '@ui-furniture/style';

const Dot = styled.divBox<{
  isActive: boolean;
}>`
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 5px;
  border-radius: 5px;
  background-color: brand-orange;
  color: brand-orange;
  transform: scale(1);
  opacity: 0;
  box-shadow: lg;

  @keyframes dot-pulse {
    0%,
    30% {
      opacity: 0;
      transform: scale(0);
      box-shadow: none;
    }
    60%,
    85% {
      opacity: 1;
      transform: scale(1);
      box-shadow: lg;
    }
    100% {
      opacity: 0;
      box-shadow: none;
    }
  }
  ${({ isActive }) =>
    isActive
      ? css`
          &:nth-child(1) {
            animation: dot-pulse 1s infinite 0s linear;
          }
          &:nth-child(2) {
            animation: dot-pulse 1s infinite 0.2s linear;
          }
          &:nth-child(3) {
            animation: dot-pulse 1s infinite 0.3s linear;
          }
        `
      : css``}
`;

export const TypingAnimation: StyledComponent<{
  isActive: boolean;
}> = ({ isActive, ...rest }) => (
  <AnimatePresence>
    <x.div
      position='relative'
      my='md'
      transition='base'
      opacity={isActive ? 1 : 0}
    >
      <x.div textAlign='left'>
        <Dot isActive={isActive} {...rest} />
        <Dot isActive={isActive} {...rest} />
        <Dot isActive={isActive} {...rest} />
      </x.div>
    </x.div>
  </AnimatePresence>
);
